import { MDBBtn, MDBDataTable, MDBIcon } from "mdbreact"
import React from 'react'
import Select from 'react-select'
import { Card, CardBody, Col, Container, Modal, ModalBody, ModalFooter, ModalHeader, Label, Row, Spinner } from 'reactstrap'
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'

const columns = [
    {
        label: "Código",
        field: "id",
        sort: "asc",
    },
    {
        label: "Colaborador",
        field: "colaborador_nombre",
        sort: "asc",
        width: 150,
    },
    {
        label: "Departamento / Area",
        field: "departamento_area_nombre",
        sort: "asc",
        width: 150,
    },
    {
        label: "Cant. Artículos",
        field: "articulo_cantidad",
        sort: "asc",
        width: 150,
    },
    {
        label: "Monto Total",
        field: "monto_total",
        sort: "asc",
        width: 150,
    },
    {
        label: "Acciones",
        field: "handle",
        width: 100
    }
];

export default class TarjetaResponsabilidad extends React.Component {

    constructor(props) {
        super(props)

        this.apiRest = new ApiRest(props);

        this.state = {
            tabla: { columns: columns, rows: [] },
            modalAbierto: false,
            modalBuscarColaboradorAbierto: false,
            mostrarSpinner: true,
            idRegistroEliminar: null,
            idColaborador: null,
            colaboradores: []
        }
    }

    componentDidMount() {
        this.cargarListado();
    }

    editarRegistro = registro => {
        this.props.history.replace({pathname: '/tarjetaResponsabilidadFormulario', registro: registro });
    }

    trasladarRegistro = registro => {
        this.props.history.replace({pathname: '/tarjetaResponsabilidadTraslado', registro: registro });
    }

    eliminarRegistro = idRegistro => {
        this.apiRest.delete('/eliminarTarjetaResponsabilidad/' + idRegistro).then(resultado => {
            if (resultado.exitoso) {
                toastr.error(resultado.data);
                this.ocultarModalEliminar();
                this.cargarListado();
            }
        });
    }

    crearNuevaTarjeta = () => {
        this.apiRest.get('/tarjetaResponsabilidadNueva/' + this.state.idColaborador).then(respuesta => {
            if (respuesta.exitoso) {
                this.props.history.replace({pathname: '/tarjetaResponsabilidadFormulario', registro: respuesta.data });
            }else{
                toastr.error('Verifique la informacion del Colaborador ya que esta incompleta para poder asignar un articulo!!!');
            }
        });
    }

    cargarListado = () => {
        this.setState( { mostrarSpinner: true });
        this.apiRest.get('/tarjetaResponsabilidad').then(respuesta => {
            if (respuesta.exitoso) {
                this.setState({  mostrarSpinner: false, tabla: this.agregarAccionesRegistro(respuesta.data) });
            }
        });
    }

    botonesListado = registro => [
        <MDBBtn className="waves-effect"size="sm" color="primary" title="Editar" onClick={() => this.editarRegistro(registro)}>
            <MDBIcon icon="far fa-edit" />
        </MDBBtn>
        , ' ',
        <MDBBtn className="waves-effect"size="sm" color="warning" title="Traslado" onClick={() => this.trasladarRegistro(registro)}>
            <MDBIcon icon="fas fa-redo" />
        </MDBBtn>
        , ' ',
        <MDBBtn className="waves-effect"size="sm" color="danger" title="Eliminar" onClick={() => this.mostrarModalEliminar(registro.id)}>
            <MDBIcon icon="fas fa-times" />
        </MDBBtn>
    ];

    agregarAccionesRegistro = rows => {
        rows.forEach(registro => registro.handle = this.botonesListado(registro));
        return { columns, rows: rows };
    };

    mostrarModalEliminar = idRegistro => {
        this.setState({ modalAbierto: true, idRegistroEliminar: idRegistro });
    }

    ocultarModalEliminar = () => {
        this.setState({ modalAbierto: false, idRegistroEliminar: null });
    }

    mostrarModalBuscarColaborador = () => {
        this.apiRest.get('/tarjetaResponsabilidadColaborador').then(respuesta => {
            if (respuesta.exitoso) {
                this.setState({ colaboradores: respuesta.data });
            } else {
                this.setState({ colaboradores: [] });
            }
        });
        this.setState({ modalBuscarColaboradorAbierto: true, idColaborador: null });
    }

    ocultarModalBuscarColaborador = () => {
        this.setState({ modalBuscarColaboradorAbierto: false, idColaborador: null });
    }

    seleccionarColaborador = colaborador => {
        this.setState({ idColaborador: colaborador.id });
    }

    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Activos" breadcrumbItem="Tarjeta de Responsabilidad" />
                        <Row>
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        <MDBBtn className="waves-effect"color="primary" onClick={() => this.mostrarModalBuscarColaborador()}>
                                            <MDBIcon icon="fas fa-user-plus" />{' '}
                                            Nueva Tarjeta
                                        </MDBBtn>
                                        <p/>

                                        { this.state.mostrarSpinner &&
                                            <Row>
                                                <Col style={{ display: "flex", justifyContent: "center" }}>
                                                    <Spinner className="m-1" color="primary" />
                                                </Col>
                                            </Row>
                                        }
                                        <div className="table-responsive">
                                            <MDBDataTable hover searchLabel="Buscar.." paginationLabel={["Anterior", "Siguiente"]} noRecordsFoundLabel="No hay datos." infoLabel={["Mostrando desde ", "hasta", " | Entradas totales: ", ""]} entriesLabel="Mostrando entradas" data={this.state.tabla} />
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>

                {/* MODAL */}
                <Modal isOpen={this.state.modalAbierto} size="mm">
                    <ModalHeader>
                        Eliminar Registro
                    </ModalHeader>
                    <ModalBody>
                        Esta seguro?
                    </ModalBody>
                    <ModalFooter className="text-center">
                        <MDBBtn className="waves-effect"color="danger" onClick={() => this.eliminarRegistro(this.state.idRegistroEliminar)}>
                            <MDBIcon icon="fas fa-trash" /> {' '}
                            Eliminar
                        </MDBBtn>
                        <MDBBtn className="waves-effect"color="warning" onClick={() => this.ocultarModalEliminar()}>
                            <MDBIcon icon="fas fa-times" /> {' '}
                            Cancelar
                        </MDBBtn>
                    </ModalFooter>
                </Modal>

                {/* MODAL */}
                <Modal isOpen={this.state.modalBuscarColaboradorAbierto} size="mm">
                    <ModalHeader>
                        Buscar Colaborador
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col lg={12}>
                                <div className="mb-3 mb-4">
                                    <Label htmlFor="name" className="form-label">
                                        Colaborador
                                    </Label>
                                    <Select
                                        name="colaboradorSeleccionado"
                                        options={this.state.colaboradores}
                                        onChange={this.seleccionarColaborador}>
                                    </Select>
                                </div>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter className="text-center">
                        <MDBBtn className="waves-effect"color="primary" onClick={() => this.crearNuevaTarjeta()}>
                            <MDBIcon icon="fas fa-trash" /> {' '}
                            Crear Tarjeta
                        </MDBBtn>
                        <MDBBtn className="waves-effect"color="warning" onClick={() => this.ocultarModalBuscarColaborador()}>
                            <MDBIcon icon="fas fa-times" /> {' '}
                            Cancelar
                        </MDBBtn>
                    </ModalFooter>
                </Modal>
            </React.Fragment>
        )
    }
}